import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { Check, Copy } from "lucide-react"
import { useState } from "react"
import { copyToClipboard } from "./copyToClipboard"

interface CopyButtonProps {
  value: string
  className?: string
}

export function CopyButton({ value, className }: CopyButtonProps) {
  const { translate } = useTranslation()
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    copyToClipboard(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={handleCopy}
      aria-label={translate(
        copied ? "MC_INQ_DRAFT_COPIED" : "MC_INQ_DRAFT_COPY",
      )}
      className={cn(
        "h-4 w-4 text-grey5 hover:bg-transparent hover:text-grey6",
        copied && "text-success hover:text-success",
        className,
      )}
    >
      {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
    </Button>
  )
}
